import { isMigratedPath, isMigratedCategoryPath } from '../migrated_routes';

describe('migrated_routes', () => {
  describe('home', () => {
    it.each(['/', '', '/es', '/es/'])('treats %p as migrated', (path) => {
      expect(isMigratedPath(path)).toBe(true);
    });
  });

  describe('advisor profile', () => {
    it.each([
      '/psychics/3461-kate-bridgerton',
      '/psychics/3461-kate-bridgerton/',
      '/es/psychics/3461-kate-bridgerton',
      '/psychics/3461-kate-bridgerton?utm_source=email'
    ])('treats %p as migrated', (path) => {
      expect(isMigratedPath(path)).toBe(true);
    });
  });

  describe('advisor list', () => {
    it.each(['/psychics', '/psychics/', '/es/psychics', '/psychics?filters=online'])('treats %p as migrated', (path) => {
      expect(isMigratedPath(path)).toBe(true);
    });
  });

  describe('category pages', () => {
    it.each(['/tarot-readings', '/tarot-readings/', '/es/lectura-de-tarot', '/tarot-readings?page=2'])('treats %p as migrated', (path) => {
      expect(isMigratedPath(path)).toBe(true);
      expect(isMigratedCategoryPath(path)).toBe(true);
    });

    it('does not treat the home page as a category', () => {
      expect(isMigratedCategoryPath('/')).toBe(false);
    });

    it('does not treat an unknown single-segment path as a category', () => {
      expect(isMigratedCategoryPath('/about-us')).toBe(false);
    });

    it('does not treat a multi-segment path as a category', () => {
      expect(isMigratedCategoryPath('/order_list/123')).toBe(false);
    });
  });

  describe('routes still owned by the SPA', () => {
    it.each([
      '/add_funds',
      '/settings',
      '/order_list',
      '/order_list/123',
      '/purchase_details',
      '/my/payment_sources',
      '/specialities',
      '/signin',
      '/about-us'
    ])('leaves %p on the client-side router', (path) => {
      expect(isMigratedPath(path)).toBe(false);
    });
  });
});
